/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 主播签约信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35761411
export const anchor_sign_info = createAsyncThunk(
  'withdraw_anchor_sign_info',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<signType>>(
      '/live/union/anchor_sign_info',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
//  主播签约 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35760170
export const anchor_sign_contract = createAsyncThunk(
  'withdraw_anchor_sign_contract',
  async (arg: signType, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/union/anchor_sign_contract',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)
// 主播编辑签约 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35761413
export const anchor_edit_contract = createAsyncThunk(
  'withdraw_anchor_edit_contract',
  async (arg: signType, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/union/anchor_edit_contract',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// app主播提现页面 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35766071
export const anchor_cash_out = createAsyncThunk(
  'withdraw_anchor_cash_out',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'balance' | 'cash_out_type' | 'payoneer_id' | 'is_cashing_out'
        >
      >
    >(
      '/live/union/anchor_cash_out',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 取钱按钮 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35766083
export const anchor_withdrawal = createAsyncThunk(
  'withdraw_anchor_withdrawal',
  async (arg: {money: number}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/union/anchor_withdrawal',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

export enum historyType {
  提现 = 101,
  薪资扣除 = 102,
  余额转金币 = 103,
  结算薪资 = 201,
  重新结算薪资 = 202,
  提现失败 = 203,
  审核失败 = 204,
}
export enum historyStatus {
  待审核 = 1,
  待打款 = 2,
  审核未通过 = 3,
  已到账 = 4,
  提现失败 = 5,
}
export interface historyListType {
  type: historyType
  time: string
  money: number
  status: historyStatus
  title?: string
  reason?: string
}
export enum review_status_enum {
  待审核 = 0,
  审核通过 = 1,
  审核不通过 = 2,
}
interface signType {
  name: string
  passport?: string
  id_card?: string
  identity_pic: string
  payoneer_id: string
  is_edit?: boolean
  review_status?: review_status_enum
}
interface InitialStateType {
  // 余额
  balance?: number
  // 提现方式
  cash_out_type?: string
  payoneer_id?: string
  // 是否有正在提现的操作
  is_cashing_out?: boolean
  // 是否在提现时间内
  is_cash_out_time?: boolean
  my_sign_info?: signType
}

const initialState: InitialStateType = {}

export const WithdrawSalarySlice = createSlice({
  name: 'WithdrawSalary',
  initialState,
  reducers: {
    resetBetRes: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        win_coins: undefined,
        bet_amounts: undefined,
        round_result: undefined,
        round_rank: undefined,
        res_day_round: undefined,
      })
    },
    changeBetLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        betLoading: action.payload,
      })
    },
    getWebMessage: (
      state,
      action: PayloadAction<{
        status_expire: number
        round_status: number
      }>
    ) => {
      Object.assign(state, action.payload)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(anchor_cash_out.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    // 获取签约信息
    builder.addCase(anchor_sign_info.fulfilled, (state, action) => {
      Object.assign(state, {my_sign_info: action.payload})
    })
  },
})
export default WithdrawSalarySlice.reducer
export const WithdrawSalaryActions = WithdrawSalarySlice.actions
